import { DialogBranch, DialogModule } from "@storyverseco/svs-dialog-ruleset";
import { DialogLike } from '../types';

/**
 * This migration got introduced because we have gone through the old schema and updated it
 * to match data/game expectations. It is a big change!!!
 */

export const migrateNewSchema = async (dialog: DialogLike): Promise<DialogLike> => {
  const oldDialog = dialog as DialogModule;

  const branch = oldDialog.scenes.scene1.branches.start as DialogBranch;

  const steps = branch.steps.map(step => ({
    navigation: step.navigation,
    gestures: step.gestures,
    parallax: step.parallax,
    camera: step.camera,
    bubble: step.bubble,
    choices: step.choices,
  }));

  const newDialog = {
    filterPreset: oldDialog.filterPreset || 'none',
    charactersMetadata: oldDialog.characters,
    initialStep: branch.initialStep,
    parallax: branch.parallax,
    characters: branch.characters,
    steps,
    timestamp: oldDialog.timestamp,
    saveCount: oldDialog.saveCount,
    editedBy: oldDialog.editedBy,
    metadata: {
      timestamp: oldDialog.timestamp,
      saveCount: oldDialog.saveCount || 0,
      editedBy: 'migrator',
    }
  }

  return newDialog;
};
